/**
 * Small Javascript class for the Denhaag Cards animation (which is denhaag.nl specific #snowflake).
 */
export default class DenhaagCardsAnimation {
  /**
   * Small and simple class.
   *
   * @param {array} elements CSS elements to add selector class on to.
   * @param {string} selector CSS selector to target the card.
   * @param {string} modifier Modifier class to toggle.
   */
  constructor(elements = ['denhaag-card-news', 'denhaag-dynamic-content__card', 'denhaag-cta-image-content'], selector = 'denhaag-card-js', modifier = 'clicked') {
    // Define selector.
    this.selector = selector;

    // Add the selector class to every element.
    [...elements].forEach( element => [...document.getElementsByClassName( element )].forEach( element => element.classList.add( this.selector ) ) );

    // Select cards to manipulate.
    this.cards = document.getElementsByClassName( this.selector );

    // If there are no cards do nothing.
    if (!this.cards) {
      return;
    }

    // Set toggle class.
    this.className = `${this.selector}--${modifier}`;
    // Initiate mouse events.
    this.events();
  }

  // Mouse events.
  events() {
    [...this.cards].forEach( card => {
      card.onclick = (e) => card.classList.replace( this.selector, this.className );
      card.onmouseleave = () => card.classList.replace( this.className, this.selector );
    } );
  }
}
